export class Product {
    id: number;
    name: string;
    description: string;
    purpose: string;
    picture: string;
    isSupeAdminHasAccess: string;
    createdDate: string;
    IsAddedByManufacturer: any;
    pictures: [];
    departments: [];
    constructor(productData: any) {
      this.id = productData.id;
      this.name = productData.name;
      this.description = productData.description;
      this.purpose = productData.purpose;
      this.createdDate = productData.createdDate;
      this.picture = productData.picture;
      this.pictures = productData.pictures;
      this.IsAddedByManufacturer = productData.IsAddedByManufacturer;
      this.departments = productData.departments;
      this.isSupeAdminHasAccess = productData.isSupeAdminHasAccess;
    }
  }
